window.VCA = window.VCA || {};

window.VCA.vetRecommendations = (function ($) {

    function init() {
        if ($('.vet-recs-lp__cards-wrapper').length <= 0) {
            return;
        }
        initVetRecommendationsImpressions();
        initSeviceRecommendationsImpressions();
        vetRecommendationsClick();
        serviceRecommendationsClick();
    }


    function initVetRecommendationsImpressions() {
        if ($('.js-vet-recommendations-card').length <= 0) {
            return;
        }
        var recommendations = [];
        $('.js-vet-recommendations-card').each(function (index) {
            let name = $(this).data('item-name');
            let id = $(this).data('item-id');
            let price = $(this).data('item-price');
            let brand = $(this).data('item-brand');
            let category = $(this).data('item-category');
            let position = index + 1;

            recommendations.push({
                'name': name,
                'id': id,
                'list': 'vet recommendations',
                'category': category,
                'brand': brand,
                'price': price,
                'position': position
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'product-impression',
            'ecommerce': {
                'impressions': recommendations
            }
        });
    }


    function vetRecommendationsClick(data) {
        $('.js-vet-recommendations-card').on('click', '.js-vet-recommendations-card-btn', function (e) {
            let $card = $(this).closest('.js-vet-recommendations-card');
            let name = $card.data('item-name');
            let id = $card.data('item-id');
            let price = $card.data('item-price');
            let brand = $card.data('item-brand');
            let category = $card.data('item-category');
            let position =  $card.index() + 1;
            let cta = $(this).text().trim();

             window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'product-click',
                    'ecommerce': {
                        'click': {
                            'actionField': {
                                'list': 'vet recommendations'
                            },
                            'products': [{
                                'name': name,
                                'id': id,
                                'list': 'vet recommendations',
                                'category': category,
                                'brand': brand,
                                'price': price,
                                'cta-text': cta,
                                'position': position
                            }]
                        }
                    }
                });
        });
    }

    function initSeviceRecommendationsImpressions() {
        if ($('.js-vet-recommendations-service').length <= 0) {
            return;
        }
        var recommendations = [];
        $('.js-vet-recommendations-service').each(function (index) {
            let name = $(this).data('item-name');
            let position = index + 1;

            recommendations.push({
                'name': name,
                'position': position
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'product-impression',
            'ecommerce': {
                'impressions': recommendations
            }
        });
    }


    function serviceRecommendationsClick(data) {
        $('.js-vet-recommendations-service').on('click', '.js-vet-recommendations-service-btn', function (e) {
            let $card = $(this).closest('.js-vet-recommendations-service');
            let name = $card.data('item-name');
            let position =  $card.index() + 1;
            let cta = $(this).text().trim();

             window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'product-click',
                    'ecommerce': {
                        'click': {
                            'actionField': {
                                'list': 'vet recommendations service'
                            },
                            'products': [{
                                'name': name,
                                'list': 'vet recommendations service',
                                'cta-text': cta,
                                'position': position
                            }]
                        }
                    }
                });
        });
    }


    return {
        init: init
    };



})(jQuery);

$(function () {
    VCA.vetRecommendations.init();
});